@for (item$ of controllableObjectDetailList$; track item$) {
  <cue-controllable-object
    (unitDataNotAvailable)="showAtLeastOneUnitNOtAvailable = true"
    [qrCodeId]="qrCodeId()"
    [qrCodeListOfResource]="qrCodeListOfResource()"
    [controllableObjectData]="(item$ | async)?.data"
    class="controllable-object"
  />
}

@if (showAtLeastOneUnitNOtAvailable && !ignoreErrors()) {
  <span class="message error"
    ><cue-icon [icon]="ICONS.cueWarning" [customIconClass]="'message-icon'" />
    {{ translation.navigation.atLeastOneUnitIsNotAvailable | transloco }}</span
  >
}
